import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon",
  "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Brazzaville)", "Congo (Kinshasa)", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt",
  "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France", "Gabon",
  "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana",
  "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
  "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi",
  "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
  "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
  "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
  "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
  "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
  "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria",
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey",
  "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

const Register = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    country: ''
  });

  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    if (!form.firstName || !form.lastName || !form.email || !form.password || !form.confirmPassword) {
      setErrorMsg('All required fields must be filled');
      return false;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(form.email)) {
      setErrorMsg('Please enter a valid email');
      return false;
    }

    if (form.password.length < 6) {
      setErrorMsg('Password must be at least 6 characters');
      return false;
    }

    if (form.password !== form.confirmPassword) {
      setErrorMsg('Passwords do not match');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (!validateForm()) return;

    try {
      const response = await fetch(`${API_BASE_URL}/UserManagement/Register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMsg(data.message || 'Registration failed');
      } else {
        setSuccessMsg(data.message || 'Registration successful');
        setForm({
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: '',
          phoneNumber: '',
          country: ''
        });
        setTimeout(() => {
          window.location.href = '/login';
        }, 1500);
      }
    } catch (err) {
      setErrorMsg('Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        <section className="shirt-client-login">
          <div className="login-form-wrapper">
            <div className="login-form-box">
              <h2 className="login-form-title">Create Account</h2>
              <form className="login-form" onSubmit={handleSubmit}>
                <input name="firstName" type="text" className="login-input" placeholder="First Name *" value={form.firstName} onChange={handleChange} required />
                <input name="lastName" type="text" className="login-input" placeholder="Last Name *" value={form.lastName} onChange={handleChange} required />
                <input name="email" type="email" className="login-input" placeholder="Email *" value={form.email} onChange={handleChange} required />
                <input name="phoneNumber" type="text" className="login-input" placeholder="Phone Number" value={form.phoneNumber} onChange={handleChange} />
                
                <select name="country" className="login-input" value={form.country} onChange={handleChange}>
                  <option value="">Select Country</option>
                  {countries.map((country, idx) => (
                    <option key={idx} value={country}>{country}</option>
                  ))}
                </select>

                <div className="position-relative">
                  <input
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    className="login-input pe-5"
                    placeholder="Password *"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: 'absolute',
                      top: '35%',
                      right: '15px',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer',
                      fontSize: '14px',
                      color: '#555'
                    }}
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </span>
                </div>

                <input
                  name="confirmPassword"
                  type={showPassword ? 'text' : 'password'}
                  className="login-input"
                  placeholder="Confirm Password *"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  required
                />

                {errorMsg && <p className="text-danger mt-2">{errorMsg}</p>}
                {successMsg && <p className="text-success mt-2">{successMsg}</p>}

                <button type="submit" className="login-btn">Register</button>
              </form>

              <p className="register-cta">
                Already have an account? <a href="/login">Login here</a>
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};

export default Register;
